import cookie from '../../util/cookie';

class LimitFn {
	constructor(pagefromUrl, $v5) {
		this.pagefromUrl = pagefromUrl;
		this.$v5 = $v5;
	}

	// 微信小程序处理
	fromWX() {
		// 小程序跳转
		this.$v5.toast('您的简历已达到上限了哦！可直接进行投递').then(() => {
			let ppu = encodeURIComponent(cookie.get('PPU')) || '';
			window.wx.miniProgram.redirectTo({
				url: `${this.pagefromUrl}&ppu=${ppu}`
			});
		});
	}

	// 百度小程序处理
	fromBD() {
		// 跳回百度小程序
		this.$v5.toast('您的简历已达到上限了哦！可直接进行投递').then(() => {
			let ppu = encodeURIComponent(cookie.get('PPU')) || '';
			window.swan.webView.redirectTo({
				url: `${this.pagefromUrl}&ppu=${ppu}`
			});
		});
	}

	// 支付宝小程序处理
	fromZFB() {
		// 跳回支付宝小程序
		this.$v5.toast('您的简历已达到上限了哦！可直接进行投递').then(() => {
			let ppu = encodeURIComponent(cookie.get('PPU')) || '';
			window.my.redirectTo({
				url: `${this.pagefromUrl}&ppu=${ppu}` //路径可以使用相对路径或绝对路径的方式进行传递
			});
		});
	}

	// 头条小程序
	fromTT() {
		// 跳转头条小程序
		this.$v5.toast('您的简历已达到上限了哦！可直接进行投递').then(() => {
			let ppu = encodeURIComponent(cookie.get('PPU')) || '';
			window.tt.miniProgram.redirectTo({
				url: `${this.pagefromUrl}&ppu=${ppu}`
			});
		});
	}

	// 默认展示达到上限提示
	defalut() {
		return true;
	}
}

export { LimitFn };



// WEBPACK FOOTER //
// ./src/module/basic/components/basic/LimitFn.js